import { Event } from './types'

interface FilterOption {
  value: string
  label: string
}

// Drives the type filter shown to the reader (tabs/dropdown), on both the
// index and calendar views.
//
// Two things are deliberately absent from this list, though `matchesFilter`
// still knows about both:
// - `course`: still a distinct webinar subtype (it groups a webinar under a
//   parent Course, e.g. for the "related course webinars" widget on its
//   detail page), but it doesn't earn its own tab on this page — a reader
//   filtering "Guest Expert" here means "a one-off live session", which
//   course webinars are too. The Library page keeps its own separate
//   Courses tab; that mapping lives in `categories.ts` and is untouched.
// - `deadlines`: session sales never appear in this list at all (they get
//   their own Programs & Courses section below, so listing them here too
//   would just be duplicating that). The calendar is the exception — it
//   always includes registration deadlines regardless of this filter, so
//   readers can see them alongside live events on one timeline. See
//   `calendarEvents` in eventindex/selectors.js.
export const FILTER_OPTIONS: FilterOption[] = [
  { value: null, label: 'All Events' },
  { value: 'curriculum', label: 'Core Curriculum' },
  { value: 'guest', label: 'Guest Expert' }
]

export const labelForFilter = (value: string): string => {
  const option = FILTER_OPTIONS.find(o => o.value === value)
  return option ? option.label : null
}

// Webinar subtypes folded into the "Guest Expert" filter on this page only.
const GUEST_EXPERT_SUBTYPES = ['guest', 'course']

export const matchesFilter = (event: Event, type: string): boolean => {
  if (!type) return true
  if (!event) return false
  if (type === 'deadlines') return event.type === 'session_sale'
  if (!event.target) return false

  if (type === 'guest') return event.type === 'webinar' && GUEST_EXPERT_SUBTYPES.includes(event.target.type)

  return event.type === 'webinar' && event.target.type === type
}
